"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ToggleButton = require("./ToggleButton.styled");
var _excluded = ["checked", "disabled", "label", "labelPlacement", "onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var PLACEMENT_LEFT = 'left';
var PLACEMENT_RIGHT = 'right';
var ToggleButton = function ToggleButton(_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    label = _ref.label,
    labelPlacement = _ref.labelPlacement,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var handleChange = function handleChange(event) {
    return onChange(event.target.checked);
  };
  var shouldShowLabel = Boolean(label.length);
  var shouldShowToTheLeft = labelPlacement === PLACEMENT_LEFT;
  var labelComponent = /*#__PURE__*/_react["default"].createElement(_ToggleButton.StyledLabel, {
    disabled: disabled,
    leftLabel: shouldShowToTheLeft,
    variant: "body1"
  }, label);
  return /*#__PURE__*/_react["default"].createElement(_ToggleButton.Wrapper, null, shouldShowLabel && shouldShowToTheLeft && labelComponent, /*#__PURE__*/_react["default"].createElement(_ToggleButton.StyledToggleButton, _extends({
    checked: checked,
    disabled: disabled,
    onChange: handleChange,
    color: "primary"
  }, rest)), shouldShowLabel && !shouldShowToTheLeft && labelComponent);
};
ToggleButton.propTypes = {
  checked: _propTypes["default"].bool.isRequired,
  disabled: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  labelPlacement: _propTypes["default"].oneOf([PLACEMENT_LEFT, PLACEMENT_RIGHT]),
  onChange: _propTypes["default"].func.isRequired
};
ToggleButton.defaultProps = {
  disabled: false,
  label: '',
  labelPlacement: PLACEMENT_RIGHT
};
var _default = exports["default"] = ToggleButton;